import type { CustomFieldValue, CustomFieldValueMap } from '../../surveyLogic/types/customFieldValues';

/** Matches `{{_c_…}}` tokens embedded in question copy (text or rich HTML). */
export const CUSTOM_FIELD_PLACEHOLDER_TOKEN = /\{\{(_c_[a-zA-Z0-9]+)\}\}/g;

export function formatCustomFieldForDisplay(value: CustomFieldValue | undefined): string {
  if (value === undefined || value === null) {
    return '';
  }

  if (Array.isArray(value)) {
    return value.filter((entry): entry is string => typeof entry === 'string' && entry !== '').join(', ');
  }

  if (typeof value === 'number') {
    return String(value);
  }

  return value;
}

export function resolveCustomFieldPlaceholders(
  html: string,
  customFieldValues: CustomFieldValueMap
): string {
  return html.replace(CUSTOM_FIELD_PLACEHOLDER_TOKEN, (match, fieldId: string) => {
    if (!(fieldId in customFieldValues)) {
      return match;
    }

    return formatCustomFieldForDisplay(customFieldValues[fieldId]);
  });
}
